import type { Routes } from '@angular/router';

import { LoginTokenGuard } from '@core/guards/login-token.guard';
import { NotLoggedGuard } from '@core/guards/not-logged.guard';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { MustBeAuthorizedGuard } from '@wizbii-components/bo-angular-ui';

export const FEATURES_ROUTES: Routes = [
  {
    path: '',
    canActivate: [NotLoggedGuard, LoginTokenGuard, MustBeAuthorizedGuard],
    loadComponent: () =>
      import('@features/layouts/dashboard-layout/dashboard-layout.component').then((m) => m.DashboardLayoutComponent),
    children: [
      {
        path: FeaturesRoutingEnum.Themes,
        loadChildren: () => import('./themes/themes.routes').then((m) => m.THEMES_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Questions,
        loadChildren: () => import('./questions/questions.routes').then((m) => m.QUESTIONS_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Transformers,
        loadChildren: () => import('./transformers/transformers.routes').then((m) => m.TRANSFORMERS_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Suggestions,
        loadChildren: () => import('./suggestions/suggestions.routes').then((m) => m.SUGGESTIONS_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Organizations,
        loadChildren: () => import('./organization/organization.routes').then((m) => m.ORGANIZATION_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Product,
        loadChildren: () => import('./products/products.routes').then((m) => m.PRODUCTS_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.Home,
        loadChildren: () => import('./home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: FeaturesRoutingEnum.NotFound,
        loadComponent: () =>
          import('@domains/not-found/resource-not-found/resource-not-found.component').then(
            (m) => m.ResourceNotFoundComponent
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('@domains/not-found/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
